module.exports = __webpack_public_path__ + "static/media/fdmedia_logo.f48279fa.svg";